if (typeof CartDrawer !== "function") {
  class CartDrawer extends HTMLElement {
    constructor() {
      super()
      this.init()

      this.addEventListener('click', (e) => {
        const drawerDimensions = this.drawerWrapper.getBoundingClientRect()
        if (e.clientX < drawerDimensions.left || e.clientX > drawerDimensions.right || e.clientY < drawerDimensions.top || e.clientY > drawerDimensions.bottom) {
          this.close()
        }
      })
    }
    init() {
      this.drawerWrapper = this.querySelector('.drawerWrapper')

      this.itemControls = this.querySelectorAll('.quantityContole')
      this.items = this.querySelectorAll('[name^="updates"]')
      this.remaining = this.querySelector('.shippingbar .remaining')
      this.checkoutButton = this.querySelector('.button--checkout')
      this.checkInsurance = this.querySelector('.check-insurance')
      this.giftNoteInput = this.querySelector('.gift_note_input')
      this.giftNote = this.querySelector('.gift_note')
      this.slider = this.querySelector('.drawerSliderContainer')
      this.insurance = this.querySelector('.parcel-insurance')
      this.closeDrawer = this.querySelector('.closeDrawer')
      this.drawerNote = this.querySelector('.drawerNote')
      this.form = this.querySelector('form')

      if (this.remaining) this.remaining.innerHTML = theme.Shopify.formatMoney((parseFloat(this.remaining.textContent)) * Shopify.currency.rate, theme.money_format_with_code_preference)
      this.initialActions()
    }
    initialActions() {
      if (this.drawerNote) {
        this.drawerNote.addEventListener('change', async () => {
          this.dataset.loading = true
          const noteReq = await fetch('/cart/update.json', {
            method: "POST",
            body: this.drawerNote.value
          })
          const noteRes = await noteReq.json()
          this.dataset.loading = false
        })
      }

      if (this.closeDrawer) {
        this.closeDrawer.addEventListener('click', () => {
          this.close()
        })
      }

      if (this.insurance) {
        this.insurance.addEventListener('change', async () => {
          this.dataset.loading = true
          if (this.insurance.checked) {
            const insurances = theme.insurances;
            let formData = new FormData();

            Object.entries(insurances).forEach(([key, val]) => {
              formData.append(`updates[${key}]`, this.insurance.dataset.id == key ? 1 : 0);
            });

            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              body: formData
            })
              .then(response => response.json())
              .then(data => this.update());
          } else {
            const insurances = theme.insurances;
            let formData = new FormData();

            Object.entries(insurances).forEach(([key, val]) => {
              formData.append(`updates[${key}]`, 0);
            });

            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              body: formData
            })
              .then(response => response.json())
              .then(data => this.update());
          }
        })
      }

      Array.from(this.itemControls).forEach(itemControl => {
        itemControl.addEventListener('click', async (e) => {
          e.preventDefault()
          const valInput = itemControl.closest('.quantity').querySelector('input')
          const itemControlID = itemControl.closest('.drawer-cart-item').dataset.id
          const cal = itemControl.classList.contains('quantityMinus') ? -1 : 1

          valInput.value = parseInt(valInput.value) + cal

          const insurances = theme.insurances;

          if (Object.keys(insurances).includes(itemControlID) && parseInt(valInput.value) === 0) {
            this.insurance.click()
          } else {
            let formData = new FormData();
            Array.from(this.items).forEach(i => {
              formData.append(`updates[${i.dataset.id}]`, i.value);
            })
            Object.entries(insurances).forEach(([key, val]) => {
              formData.append(`updates[${key}]`, 0);
            });

            this.dataset.loading = true
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              body: formData
            })
              .then(res => res.json())
              .then(res => {
                if (this.insurance && this.insurance.checked) {
                  const insurancesPlans = theme.insurancesPlans;
                  let insuranceformData = new FormData();
                  let insuranceQty = Object.keys(insurances).includes(itemControlID) ? valInput.value : 1;

                  Object.entries(insurancesPlans).forEach(([key, val]) => {
                    insuranceformData.append(`updates[${key}]`, (res.total_price > val.min && val.min > val.max) || (res.total_price > val.min && val.max > res.total_price) ? insuranceQty : 0);
                  });

                  fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    body: insuranceformData
                  })
                    .then(response => response.json())
                    .then(data => this.update());
                } else {
                  this.update()
                }
              });
          }
        })
      })

      if (this.giftNoteInput) this.giftNoteInput.addEventListener('change', () => {
        let formData = new FormData();
        this.giftNote.innerHTML = ""
        formData.append(`updates[${this.giftNoteInput.dataset.id}]`, this.giftNoteInput.checked ? 1 : 0);
        formData.append(`attributes[Gift Note]`, this.giftNote.value);

        this.dataset.loading = true
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then(data => this.update());
      })

      if (this.giftNote) (
        this.giftNote.addEventListener('input', () => {
          if (this.giftNote.value.length > 300) {
            this.giftNote.value = this.giftNote.value.slice(0, 300);
          }
        }),
        this.giftNote.addEventListener('change', () => {
          let formData = new FormData();

          formData.append(`attributes[Gift Note]`, this.giftNote.value);

          this.dataset.loading = true
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            body: formData
          })
            .then(response => response.json())
            .then(data => this.update());
        })
      )
    }
    async update(show = true) {
      if (show) {
        this.show()
      }
      this.dataset.loading = true
      await this.render()
      this.init()
      this.dataset.loading = false
    }
    async render() {
      const drawerReq = await fetch('/pages/cart-drawer?view=cart-ajax')
      const drawerRes = await drawerReq.text()
      const $html = (new DOMParser()).parseFromString(drawerRes, "text/html")

      this.querySelector('.drawerWrapper').innerHTML = $html.querySelector('.drawerContainer').querySelector('.drawerWrapper').innerHTML
    }
    renderSlider() {
      jQuery(this.slider).slick({
        arrows: true,
        dots: false,
        infinite: true,
        nextArrow: '<svg class="slickArrow slickArrowRight" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 215 370.8"><polygon points="165.3,185.4 0,346 24.1,370.8 215,185.4 24.1,0 0,24.8"/></svg>',
        prevArrow: '<svg class="slickArrow slickArrowLeft" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 215 370.8"><polygon points="215,24.8 190.9,0 0,185.4 190.9,370.8 215,346 49.7,185.4"/></svg>',
        slidesToScroll: 1,
        slidesToShow: 3,
      })
    }
    close() {
      const el = window.getComputedStyle(this.drawerWrapper)
      const delay = (el['animation-duration']).includes("ms") ? parseInt(el['animation-duration']) : parseFloat(el['animation-duration']) * 1000

      document.body.classList.add('drawer-closing')

      setTimeout(() => {
        document.body.classList.remove('drawer-closing', 'drawer-open')
      }, delay);
    }
    show() {
      document.body.classList.add('drawer-open')
      this.renderSlider()
    }
  }
  customElements.define("cart-drawer", CartDrawer)
}

if (typeof CCAnnouncement !== "function") {
  class CCAnnouncement extends HTMLElement {
    constructor() {
      super()
      const template = this.querySelector('template')
      this.template = template.content.cloneNode(true)
      this.continentMapping = {
        "AF": "africa",
        "AN": "antarctica",
        "AS": "asia",
        "EU": "europe",
        "NA": "north america",
        "OC": "oceania",
        "SA": "south america",
      }

      this.init()
    }
    async init() {
      this.render(await this.getLocation())
    }
    async getLocation() {
      try {
        const req = await fetch('https://ipapi.co/json/');
        if (!req.ok) {
          throw new Error('Network response was not ok');
        }
        const res = await req.json();
        return {
          "continent": {
            code: res.continent_code,
            name: this.continentMapping[res.continent_code],
          }, "country": {
            codeIso3: (res.country_code_iso3).toLowerCase(),
            code: (res.country_code).toLowerCase(),
            name: (res.country_name).toLowerCase()
          }
        }
      } catch (error) {
        return {};
      }
    }
    render(loc) {
      Array.from(this.querySelectorAll('.cc-announcement--location')).forEach(el => el.remove())

      if (loc.continent) {
        const continentAnnouncements = this.template.querySelectorAll(`[data-loaction="${loc.continent.code}"], [data-loaction="${loc.continent.name}"]`)
        Array.from(continentAnnouncements).forEach(el => this.querySelector('.cc-announcement--slider').append(el))
      }
      if (loc.country) {
        const countryAnnouncements = this.template.querySelectorAll(`[data-loaction="${loc.country.codeIso3}"], [data-loaction="${loc.country.code}"], [data-loaction="${loc.country.name}"]`)
        Array.from(countryAnnouncements).forEach(el => this.querySelector('.cc-announcement--slider').append(el))
      }

      this.style.display = "block"
      this.slider()
    }
    slider() {
      jQuery(this.querySelector('.cc-announcement--slider')).slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: false,
        infinite: true,
        vertical: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              vertical: false
            }
          }
        ]
      })
    }
  }
  customElements.define("cc-announcement", CCAnnouncement)
}

if (typeof CollectionBlocks !== 'function') {
  class CollectionBlocks extends HTMLElement {
    constructor() {
      super();
      this.main = this.querySelector('.swiper');
      this.mainSwiper = null; // Fixed typo (was `mainSwipper`)

      this.mainSettings = {
        breakpoints: {
          750: {
            enabled: false, // This prevents interactions but does not fully destroy Swiper
          },
        },
        freeMode: true,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        scrollbar: {
          el: this.querySelector(".swiper-scrollbar"),
          hide: false,
        },
        slidesPerView: 1,
        spaceBetween: 15,
      };

      this.init();
      document.addEventListener('shopify:section:load', () => {
        this.appendAssets();
        this.init();
      });

      window.addEventListener("resize", () => {
        setTimeout(() => this.init(), 300); // Prevent flickering on resize
      });
    }

    appendAssets() {
      if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        document.head.appendChild(link);
      }

      if (!document.querySelector('script[src*="swiper-bundle.min.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        document.body.appendChild(script);
      }
    }

    init() {
      if (typeof Swiper !== 'function') {
        this.appendAssets();
        this.swiperChecker();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      if (this.mainSwiper) {
        this.mainSwiper.destroy(true, true);
        this.mainSwiper = null;
      }

      if (window.innerWidth < 750) { // Run Swiper only on mobile
        this.mainSwiper = new Swiper(this.main, this.mainSettings);
      }
    }

    swiperChecker() {
      const interval = setInterval(() => {
        if (typeof Swiper === 'function') {
          clearInterval(interval);
          this.initSlider();
        }
      }, 100);
    }
  }

  customElements.define('collection-blocks', CollectionBlocks);
}


const cartButtons = document.querySelectorAll('.cart-type--drawer')
Array.from(cartButtons).forEach(cartButton => {
  cartButton.addEventListener('click', (e) => {
    e.preventDefault()

    if (document.querySelector('cart-drawer')) {
      document.querySelector('cart-drawer').show();
    } else {
      window.location.href = "/cart"
    }
  })
})
const partnerSitesContext = document.getElementById('shopify-section-partner-sites')
const partnerSitesTarget = document.getElementById('partnerSites')
if (partnerSitesContext) {
  const links = partnerSitesContext.querySelectorAll('.partnerSiteLink')

  Array.from(links).forEach(link => link.classList.toggle('active', link.href.includes(window.location.origin)))

  if (partnerSitesTarget) partnerSitesTarget.innerHTML = partnerSitesContext.innerHTML
  partnerSitesContext.innerHTML = ""
}

jQuery(document).ready(function ($) {
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true
  });

  $('.slider-for').on('afterChange', function (e, slick, currentSlide) {
    videoHandle(slick.$slides)
  });

  $(document).on('mouseenter', '.product-list .product-block__inner', (el) => {
    if (($(el.currentTarget).find('video')).length > 0) $(el.currentTarget).find('video')[0].play()
  })
  $(document).on('mouseleave', '.product-list .product-block__inner', (el) => {
    if (($(el.currentTarget).find('video')).length > 0) $(el.currentTarget).find('video')[0].pause()
  })
});

function videoHandle(slides) {
  Array.from(slides).forEach(slide => {
    if (slide.classList.contains('slick-current') && slide.querySelector('.media-video')) {
      slide.querySelector('.media-video').play()
    } else {
      if (slide.querySelector('.media-video')) {
        slide.querySelector('.media-video').pause()
        slide.querySelector('.media-video').currentTime = 0
      }
    }
  })
}

document.addEventListener('readystatechange', () => {
  if (document.readyState == "complete") {
    const productArea = document.querySelector('.product-area')
    const swatches = productArea?.querySelectorAll('.cc-swatches .clickyboxes a')

    if (swatches) {
      Array.from(swatches).forEach(swatch => {
        swatch.addEventListener('click', () => {
          const pseudoElement = window.getComputedStyle(swatch, '::before');
          const pseudoImage = pseudoElement.getPropertyValue('background-image').replace(/url\(["']?(?:https?:\/\/)?([^/?]+\/[^?]+).*["']?\)/, '$1')
          if (pseudoImage) {
            const sliderNavImages = productArea.querySelector(`.slider-nav img[src*="${pseudoImage}"]`)
            if (sliderNavImages) sliderNavImages?.closest('.swiper-slide')?.click()
          }
        })
      })
    }
  }
})